import { Optional } from "csi/typings";
import React, { FunctionComponent } from "react";
import ConfirmDialog, { ConfirmDialogProps } from "designSystem/components/dialog/ConfirmDialog";
import NotifyCollaboratorsStore from "./NotifyCollaboratorsStore";
import { observer } from "mobx-react-lite";

export interface NotifyCollaboratorsProps extends Optional<ConfirmDialogProps, "category"> {

	store?: NotifyCollaboratorsStore;
}

const NotifyCollaboratorsDialog: FunctionComponent<NotifyCollaboratorsProps> = observer((props) => {
	const {
		store,
		onClose,
	} = props;

	const { onConfirm } = store || {};

	return (store && (
		<ConfirmDialog
			category="warn"
			confirmRes="NotifyCollaborators"
			messageRes="NotifyCollaboratorsMessage"
			onCancel={onClose}
			onConfirm={onConfirm}
			open
			titleRes="NotifyCollaborators"
		/>
	));
});

export default NotifyCollaboratorsDialog;